import { PossibleEnvironment, possibleEnvironments } from "./types";

export default function compute(w: Window) {
  const h = "production"
  if (h === "development") return "development";
  if (h === "staging") return "staging";
  if (h === "production") return "production";
  return "production";
}
